import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sidebar_right__activity",
  "use": "sidebar_right__activity-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"sidebar_right__activity\">\n  <path d=\"M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z\" />\n  <path d=\"M10.919 7.96a.5.5 0 1 0-.982.19l1.145 5.89a.5.5 0 1 0 .982-.19l-1.145-5.89Z\" />\n  <path d=\"M15.853 13.646c.147.492.09.617 0 .708a.499.499 0 0 1-.353.146h-4a.499.499 0 1 1 0-1h4c.138 0 .263.056.353.146Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol